import { getRiskTypeApi } from './api'

export const state = {
  riskTypes: [],
  isRiskTypeLoaded: false,
}

export const getters = {
  riskTypeOptions(state) {
    return state.riskTypes
  },
  isRiskTypeLoaded(state) {
    return state.isRiskTypeLoaded
  },
}

export const mutations = {
  SET_RISK_TYPE(state, payload) {
    state.riskTypes = payload
    state.isRiskTypeLoaded = true
  },
  SET_LOADING(state, payload) {
    state.isRiskTypeLoaded = payload
  },
}

export const actions = {
  fetch({ commit }) {
    getRiskTypeApi(true).then((data) =>
      commit('SET_RISK_TYPE', Object.freeze(data))
    )
  },

  /**
   * destroy all states when user is logged out
   */
  destroy({ commit }) {
    commit('SET_RISK_TYPE', [])
    commit('SET_LOADING', false)
  },
}
